import currency from 'currency.js';

export default function formatCurrency(amount: number, showEuroSign: boolean = true) {
  return currency(amount, {
    symbol: showEuroSign ? '€ ' : '',
    separator: '.',
    decimal: ',',
  }).format();
}
